/** Режим поля ответа «Чатов»: сообщение клиенту, комментарий к сделке CRM или вопрос в группу
 * салона города (`/api/chats/{id}/comment`, `/api/chats/{id}/salon`).
 * Спека `docs/specs/2026-10-23-chat-compose-modes-design.md`. */
import { apiFetch } from "@/lib/api";
import type { Podbor } from "@/lib/podbor";

export type ComposeMode = "message" | "comment" | "salon";

/** Вопрос салону: куда можно отправить, город чата и кого отметим. */
export type SalonForm = {
  deal: number | null;
  /** Город чата, если у его салона есть группа; `null` — выбрать руками. */
  city: number | null;
  cities: { id: number; name: string; group: string }[];
  /** Кто вёл последнюю примерку по сделке — его отметим в группе. */
  stylist: { name: string; date: string; telegram: boolean } | null;
};

export const loadSalonForm = (chatId: number) => apiFetch<SalonForm>(`/api/chats/${chatId}/salon`);

/** Комментарий к сделке чата в CRM: виден в сделке, договоре и карточке клиента CRM и в ленте чата. */
export const sendComment = (chatId: number, text: string) =>
  apiFetch<{ deal: number; comment_id: number }>(`/api/chats/${chatId}/comment`, {
    method: "POST",
    body: JSON.stringify({ text }),
  });

/** Комментарий к сделке + вопрос в группу салона города; ответы реплаем лягут ответами на комментарий. */
export const sendSalonQuestion = (chatId: number, body: { text: string; city: number }) =>
  apiFetch<{ deal: number; comment_id: number; podbor: Podbor }>(`/api/chats/${chatId}/salon`, {
    method: "POST",
    body: JSON.stringify(body),
  });
